// extracted by mini-css-extract-plugin
export var carrierTab = "_5m-0";
export var carrierTabActive = "_5m-1 _5m-0";
export var carrierTabInactive = "_5m-2 _5m-0";
export var carrierTabLabel = "_5m-3";
export var carrierTabLabelActive = "_5m-4 _5m-3";
export var carrierTabLabelInactive = "_5m-5 _5m-3";
export var carrierTabPercentage = "_5m-6";
export var carrierTabPercentageActive = "_5m-7 _5m-6";
export var carrierTabPercentageInactive = "_5m-8 _5m-6";
export var carrierTabWinnable = "_5m-9";
export var carrierTabWinnableActive = "_5m-a _5m-9";
export var carrierTabWinnableInactive = "_5m-b _5m-9";
export var comparisonContainer = "_5m-d";
export var missingRateButton = "_5m-n";
export var missingRateButtonActive = "_5m-o _5m-n";
export var missingRateButtonInactive = "_5m-p _5m-n";
export var missingRateButtonLabel = "_5m-q";
export var missingRateButtonLabelActive = "_5m-r _5m-q";
export var missingRateButtonLabelInactive = "_5m-s _5m-q";
export var sidebar = "_5m-c";
export var strategyButton = "_5m-e";
export var strategyButtonActive = "_5m-f _5m-e";
export var strategyButtonDescription = "_5m-k";
export var strategyButtonDescriptionActive = "_5m-l _5m-k";
export var strategyButtonDescriptionInactive = "_5m-m _5m-k";
export var strategyButtonInactive = "_5m-g _5m-e";
export var strategyButtonLabel = "_5m-h";
export var strategyButtonLabelActive = "_5m-i _5m-h";
export var strategyButtonLabelInactive = "_5m-j _5m-h";
export var unitToggleButton = "_5m-t";
export var unitToggleButtonActive = "_5m-u _5m-t";
export var unitToggleButtonInactive = "_5m-v _5m-t";
export var unitToggleButtonLabel = "_5m-w";
export var unitToggleButtonLabelActive = "_5m-x _5m-w";
export var unitToggleButtonLabelInactive = "_5m-y _5m-w";